(function () {
  'use strict';

  /* @ngdoc object
   * @name crewCreditHoursReport
   * @description
   *
   */
  angular
    .module('crewCreditHoursReport', [
      'ui.router'
    ]);
}());
